module.exports = {
  INSTRUMENT_TYPE: {
    CARD: 'CARD',
    BANK_ACCOUNT: 'BANK_ACCOUNT'
  }
};
